module.exports = __webpack_public_path__ + "static/media/blue_payout_correct_100.ae2416c7.png";